.text {
  font-family: var(--font-family);
  font-size: var(--rasa-text-font-size, 13px);
  font-style: normal;
  font-weight: var(--rasa-text-font-weight, 400);
  line-height: var(--rasa-text-line-height, 150%);
  letter-spacing: var(--rasa-text-letter-spacing, 0.6px);
  overflow-wrap: break-word;
  white-space: pre-wrap;

  &--bold {
    font-weight: bold;
  }

  &--italic {
    font-style: italic;
  }
}
